import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setTokens } from '../lib/api';

export default function AuthCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const access = params.get('access');
    const refresh = params.get('refresh');

    if (access && refresh) {
      setTokens({ access, refresh });
      // Use window.location.href for a full page reload to ensure all states are clean
      // and re-fetched from the server/local storage correctly.
      window.location.href = '/';
    } else {
      // Missing tokens: redirect to a simple login flow (root where login button is visible)
      navigate('/');
    }
  }, [navigate, params]);

  return <div className="container"><div className="grid-state">Logging you in...</div></div>;
}
